import React, { useCallback, useState } from 'react'
import { connect } from 'react-redux'

import { Alert, Align, Button } from 'component-library-next'
import { omit } from 'ramda'

import Loader from '@app/common/Components/Loader'
import { ISelectedEmailTemplate } from '@app/modules/Messages/Components/AnswerArea/AnswerArea'
import { RequestedLetterNotAddedPopUp } from '@app/modules/Messages/Components/RequestedLetterNotAddedPopUp'
import LawyerChatAction from '@app/modules/Messages/store/actions'
import { LawyerChatState } from '@app/modules/Messages/store/models'
import { Message } from '@app/queries/CustomerAsLawyer/models'

type OwnProps = {
  lastQuestion: Message
  latestMessageId: number
  customer
  requestedLetterNotAdded: boolean
  selectedEmailTemplate?: ISelectedEmailTemplate
  setSelectedEmailTemplate?: React.Dispatch<React.SetStateAction<ISelectedEmailTemplate | null>>
}

type ConnectedProps = {
  notes
  showErrors
  lawyerAnswer
  sending
  answerError
}

const AnswerButtons = ({
  customer,
  lastQuestion,
  sending,
  answerError,
  requestedLetterNotAdded,
  notes,
  showErrors,
  lawyerAnswer,
  latestMessageId,
  selectedEmailTemplate,
  setSelectedEmailTemplate
}: OwnProps & ConnectedProps) => {
  const [showRequestedLetterNotAddedPopUp, setShowRequestedLetterNotAddedPopUp] = useState(false)

  const sendData = useCallback(() => {
    if (!notes) {
      return showErrors(showErrors)
    }

    const data = {
      message: notes
    }

    lawyerAnswer({
      data,
      latestMessageId,
      templateId: selectedEmailTemplate?.id,
      caseId: lastQuestion.case?.id,
      customerId: customer.id
    })
    typeof setSelectedEmailTemplate === 'function' && setSelectedEmailTemplate(null)
  }, [notes, showErrors, selectedEmailTemplate])

  const checkForLetterBeforeSubmit = useCallback(() => {
    if (requestedLetterNotAdded) {
      setShowRequestedLetterNotAddedPopUp(true)
      return
    }
    sendData()
  }, [requestedLetterNotAdded, sendData])

  return (
    <>
      {sending && <Loader />}

      <Align direction={Align.directions.flexEnd}>
        <Button disabled={sending} size={Button.sizes.medium} onClick={checkForLetterBeforeSubmit}>
          Antwort senden
        </Button>
      </Align>

      {showRequestedLetterNotAddedPopUp && (
        <RequestedLetterNotAddedPopUp
          closePopUp={() => setShowRequestedLetterNotAddedPopUp(false)}
          sendAnswer={() => {
            setShowRequestedLetterNotAddedPopUp(false)
            sendData()
          }}
        />
      )}

      {answerError && (
        <Alert color={Alert.colors.warning}>
          Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.
        </Alert>
      )}
    </>
  )
}

const ConnectedButtons = connect(
  ({ lawyerChat }: { lawyerChat: LawyerChatState }) => ({ ...omit(['customer'], lawyerChat) }),
  {
    lawyerAnswer: LawyerChatAction.lawyerAnswer,
    showErrors: LawyerChatAction.showErrors
  }
)(AnswerButtons)

export { ConnectedButtons as AnswerButtons }
